'use strict';

var TNHeroSlider = (function () {

  var _initialised = {};

  /* ── Destroy any active player (stops audio immediately) ── */
  function _destroyPlayer(playerEl) {
    if (!playerEl) return;
    var iframe = playerEl.querySelector('iframe');
    if (iframe) { iframe.src = ''; iframe.remove(); }
    var video = playerEl.querySelector('video');
    if (video) { video.pause(); video.src = ''; video.load(); video.remove(); }
    playerEl.innerHTML = '';
  }

  /* ── Init one section ── */
  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var wrap    = document.getElementById('tnnursery-video-' + sectionId);
    var track   = document.getElementById('tn-track-'        + sectionId);
    var prevBtn = document.getElementById('tn-prev-'         + sectionId);
    var nextBtn = document.getElementById('tn-next-'         + sectionId);
    var dotsEl  = document.getElementById('tn-dots-'         + sectionId);

    if (!wrap || !track) return;

    /* ── Settings from data attributes ── */
    var totalSlides = parseInt(wrap.dataset.totalSlides, 10) || 1;
    var autoPlay    = wrap.dataset.autoplay !== 'false';   /* default true */
    var loopSlides  = wrap.dataset.loop     !== 'false';   /* default true */
    var autoDelay   = parseInt(wrap.dataset.speed, 10) || 4000;

    var currentSlide  = 0;
    var activeVbBlock = null;  /* currently playing video_block element */
    var touchStartX   = 0;
    var touchStartY   = 0;
    var didSwipe      = false;
    var autoTimer     = null;

    /* ── Auto-slide ── */
    function stopAutoSlide() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    function startAutoSlide() {
      stopAutoSlide();
      if (!autoPlay || totalSlides <= 1) return;
      if (!loopSlides && currentSlide >= totalSlides - 1) return;

      autoTimer = setInterval(function () {
        if (activeVbBlock) return;
        var next = currentSlide + 1;
        if (next >= totalSlides) {
          if (loopSlides) { next = 0; }
          else            { stopAutoSlide(); return; }
        }
        goToSlide(next);
      }, autoDelay);
    }

    /* ── Per-block video open / close ── */
    function openBlockVideo(blockEl) {
      if (activeVbBlock && activeVbBlock !== blockEl) closeBlockVideo(activeVbBlock);

      var vbYt  = (blockEl.dataset.vbYoutube || '').trim();
      var vbMp4 = (blockEl.dataset.vbMp4     || '').trim();
      if (!vbYt && !vbMp4) return;

      var vbPlayer = document.getElementById('tn-vb-player-' + blockEl.id.replace('tn-vb-', ''));
      if (!vbPlayer) return;

      stopAutoSlide();
      activeVbBlock = blockEl;
      blockEl.classList.add('tn-vb-playing');

      if (vbYt) {
        var iframe         = document.createElement('iframe');
        iframe.src         = 'https://www.youtube.com/embed/' + vbYt + '?autoplay=1&rel=0&enablejsapi=1';
        iframe.allow       = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        iframe.title       = 'Video';
        iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;border-radius:inherit;';
        vbPlayer.appendChild(iframe);
      } else {
        var video          = document.createElement('video');
        video.src          = vbMp4;
        video.autoplay     = true;
        video.controls     = true;
        video.playsInline  = true;
        video.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:inherit;';
        vbPlayer.appendChild(video);
        var p = video.play();
        if (p !== undefined) p.catch(function () {});
      }
    }

    function closeBlockVideo(blockEl) {
      if (!blockEl) return;
      var vbPlayer = document.getElementById('tn-vb-player-' + blockEl.id.replace('tn-vb-', ''));
      _destroyPlayer(vbPlayer);
      blockEl.classList.remove('tn-vb-playing');
      if (activeVbBlock === blockEl) activeVbBlock = null;
      startAutoSlide();
    }

    /* ── Dots + arrows ── */
    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.tn-dot').forEach(function (dot, i) {
        var active = i === currentSlide;
        dot.classList.toggle('tn-dot--active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      /* Only dim at boundaries when NOT looping */
      var atStart = !loopSlides && currentSlide === 0;
      var atEnd   = !loopSlides && currentSlide === totalSlides - 1;
      prevBtn.style.opacity       = atStart ? '0.35' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none'  : '';
      nextBtn.style.opacity       = atEnd   ? '0.35' : '1';
      nextBtn.style.pointerEvents = atEnd   ? 'none'  : '';
    }

    /* ── Navigate ── */
    function goToSlide(index) {
      if (loopSlides) {
        index = (index + totalSlides) % totalSlides;
      } else {
        if (index < 0 || index >= totalSlides) return;
      }
      /* Close any playing block video when leaving that slide */
      if (activeVbBlock) closeBlockVideo(activeVbBlock);
      currentSlide = index;
      track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      updateDots();
      updateArrows();

      /* Handle all slides after transition */
      var allSlides = track.querySelectorAll('.tn-slide');
      allSlides.forEach(function (slide, i) {

        /* ── autoplay_video: play active, pause inactive ── */
        if (slide.classList.contains('tn-slide--autoplay-video')) {
          var av = slide.querySelector('.tn-av-video');
          if (av) {
            if (i === currentSlide) {
              var p = av.play();
              if (p !== undefined) p.catch(function () {});
            } else {
              av.pause();
              /* Re-mute when leaving so it starts muted next time */
              av.muted = true;
              slide.classList.remove('tn-av-unmuted');
            }
          }
        }

        /* ── video_block: auto-open if vbAutoplay set ── */
        if (slide.classList.contains('tn-slide--video-block') && i === currentSlide && slide.dataset.vbAutoplay === 'true') {
          openBlockVideo(slide);
        }
      });
    }

    /* ── Initial state ── */
    updateArrows();

    /* ── Per-block play buttons ── */
    wrap.addEventListener('click', function (e) {
      var playBtn = e.target.closest('.tn-vb-play-btn');
      if (!playBtn) return;
      e.stopPropagation();
      var blockEl = playBtn.closest('.tn-slide--video-block');
      if (blockEl) openBlockVideo(blockEl);
    });

    /* ── Autoplay video slide: click to unmute + restart with audio ── */
    wrap.addEventListener('click', function (e) {
      /* Ignore if clicking controls */
      if (e.target.closest('.tn-arrow')) return;
      if (e.target.closest('.tn-dots'))  return;
      if (e.target.closest('.tn-vb-play-btn')) return;
      if (e.target.closest('.tn-vb-close'))    return;

      var avSlide = e.target.closest('.tn-slide--autoplay-video');
      if (!avSlide) return;

      var av = avSlide.querySelector('.tn-av-video');
      if (!av) return;

      if (av.muted) {
        /* First click: unmute and restart from beginning with audio */
        av.muted  = false;
        av.currentTime = 0;
        var p = av.play();
        if (p !== undefined) p.catch(function () { av.muted = true; });
        avSlide.classList.add('tn-av-unmuted');
      } else {
        /* Second click: mute again */
        av.muted = true;
        avSlide.classList.remove('tn-av-unmuted');
      }
    });

    /* ── Per-block close buttons ── */
    wrap.addEventListener('click', function (e) {
      var closeB = e.target.closest('.tn-vb-close');
      if (!closeB) return;
      e.stopPropagation();
      var blockEl = closeB.closest('.tn-slide--video-block');
      if (blockEl) closeBlockVideo(blockEl);
    });

    /* ── Prev / next arrows ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goToSlide(currentSlide - 1);
        if (autoPlay) startAutoSlide();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goToSlide(currentSlide + 1);
        if (autoPlay) startAutoSlide();
      });
    }

    /* ── Dots ── */
    if (dotsEl) {
      dotsEl.querySelectorAll('.tn-dot').forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          goToSlide(parseInt(dot.dataset.index, 10));
          if (autoPlay) startAutoSlide();
        });
      });
    }

    /* ── Touch / swipe disabled ── */
    /* Re-enable by restoring touchstart / touchend listeners here */

    /* ── Pause on desktop hover ── */
    wrap.addEventListener('mouseenter', stopAutoSlide);
    wrap.addEventListener('mouseleave', function () {
      if (!activeVbBlock) startAutoSlide();
    });

    /* ── Kick off autoplay ── */
    startAutoSlide();

    /* ── On init: handle first slide and pause all non-active slides ── */
    (function () {
      var allSlides = track.querySelectorAll('.tn-slide');
      allSlides.forEach(function (slide, i) {

        /* Pause autoplay_video slides that are not slide 0 */
        if (slide.classList.contains('tn-slide--autoplay-video')) {
          var av = slide.querySelector('.tn-av-video');
          if (av && i !== 0) av.pause();
        }

        /* Auto-open video_block on slide 0 if vbAutoplay set */
        if (i === 0 && slide.classList.contains('tn-slide--video-block') && slide.dataset.vbAutoplay === 'true') {
          openBlockVideo(slide);
        }
      });
    })();
  }

  return { init: init };

})();

/* ── Auto-init fallback for Theme Editor re-renders ── */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tnnursery-video-"]').forEach(function (el) {
    TNHeroSlider.init(el.id.replace('tnnursery-video-', ''));
  });
});